import React, { createContext, useContext, useState } from 'react';
import ImpSnackbar, { SNACKBAR_ANIMATION_DURATION_MS } from './ImpSnackbar';
import { TEMP_SNACKBAR_DURATION, } from './ImpSnackbarTypes';
const ImpSnackbarContext = createContext({
    snackbars: [],
    displayTemporarySnackbar: () => 0,
    displayPersistentSnackbar: () => 0,
    updateSnackbar: () => { },
    clearAllSnackbars: () => { },
    clearSnackbar: () => { },
});
export const useSnackbar = () => {
    const context = useContext(ImpSnackbarContext);
    if (!context) {
        throw new Error('useSnackbar must be used within a SnackbarProvider');
    }
    return context;
};
export default function ImpSnackbarProvider({ props, children, }) {
    const [snackbars, setSnackbars] = useState([]);
    const displayTemporarySnackbar = (payload) => {
        const id = new Date().getTime() || 0;
        const newSnackbar = {
            id,
            isVisible: false, // Initially set to false
            buttonClick: () => {
                var _a;
                if (!payload.persistOnButtonClick)
                    clearSnackbar(id);
                (_a = payload.onButtonClick) === null || _a === void 0 ? void 0 : _a.call(payload);
            },
            ...payload,
        };
        // Adding snackbar to state
        setSnackbars((prevSnackbars) => [...prevSnackbars, newSnackbar]);
        // Set visibility to true for the new snackbar to start animation
        setTimeout(() => {
            setSnackbars((prevSnackbars) => prevSnackbars.map((snackbar) => snackbar.id === id ? { ...snackbar, isVisible: true } : snackbar));
        }, 0);
        // Hiding the snackbar after its duration
        setTimeout(() => {
            setSnackbars((prevSnackbars) => prevSnackbars.map((snackbar) => snackbar.id === id ? { ...snackbar, isVisible: false } : snackbar));
        }, TEMP_SNACKBAR_DURATION);
        // Removing the snackbar after allowing time for the exit animation
        setTimeout(() => {
            setSnackbars((prevSnackbars) => prevSnackbars.filter((snackbar) => snackbar.id !== id));
        }, TEMP_SNACKBAR_DURATION + SNACKBAR_ANIMATION_DURATION_MS);
        return id;
    };
    const displayPersistentSnackbar = (payload) => {
        const id = new Date().getTime() || 0;
        const newSnackbar = {
            id,
            isVisible: false,
            ...payload,
        };
        setSnackbars((prevSnackbars) => [...prevSnackbars, newSnackbar]);
        setTimeout(() => {
            setSnackbars((prevSnackbars) => prevSnackbars.map((snackbar) => snackbar.id === id ? { ...snackbar, isVisible: true } : snackbar));
        }, 0);
        return id;
    };
    const updateSnackbar = (id, payload) => {
        setSnackbars((prevSnackbars) => prevSnackbars.map((snackbar) => snackbar.id === id ? { ...snackbar, ...payload } : snackbar));
    };
    const clearAllSnackbars = () => {
        setTimeout(() => {
            setSnackbars((prevSnackbars) => prevSnackbars.map((snackbar) => ({
                ...snackbar,
                isVisible: false,
            })));
        }, 0);
        setTimeout(() => {
            setSnackbars([]);
        }, SNACKBAR_ANIMATION_DURATION_MS);
    };
    const clearSnackbar = (id) => {
        setSnackbars((prevSnackbars) => prevSnackbars.map((snackbar) => snackbar.id === id ? { ...snackbar, isVisible: false } : snackbar));
        setTimeout(() => {
            setSnackbars((prevSnackbars) => prevSnackbars.filter((snackbar) => snackbar.id !== id));
        }, SNACKBAR_ANIMATION_DURATION_MS);
    };
    return (React.createElement(ImpSnackbarContext.Provider, { value: {
            snackbars,
            displayTemporarySnackbar,
            displayPersistentSnackbar,
            updateSnackbar,
            clearAllSnackbars,
            clearSnackbar,
        } },
        children,
        snackbars
            .slice()
            .reverse()
            .map((snackbar, index) => (React.createElement(ImpSnackbar, { key: snackbar.id, snackbar: snackbar, index: index })))));
}
//# sourceMappingURL=ImpSnackbarProvider.js.map